import React from 'react'
import style from  "../TermAndPolicy/TermAndPolicy.module.css"
import SlideUpWrapper from '../../components/Transitions/SlideUpWrapper'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { updateUser } from '../../Utils/Redux/UserSlice'
import Header from '../../components/DashBoard/Header'

    // const dispatch=useDispatch()
    // const User=useSelector(state=>state.User)
    // const navigate=useNavigate();
    // const handleNavigate=(e)=>{

    //     e.preventDefault()
    //     dispatch(updateUser({
    //         user_name:User.email
    //     }))        
    //     navigate("/dashboard")

    // }
    // const representation=[
    //     {
    //     points:"You have a specific and permissible purpose to access this data."
    //     },
    //     {
    //     points:"You have obtained prior written authorization from the Individual to verify his/her details for employment purpose. You will maintain and produce the written authorization of the individual in case of any dispute on verification via AuthNumber."},
    //     {points:"You have maintained and will produce separate authorizations of the same individual in more than one employer verifications conducted on AuthNumber."},
    //     {points:"Service is provided to you solely on condition that the data provided will be used only for the specific purpose for which the consent is received from the individual. Any usage of data for any other purpose is prohibited."}

    // ]
const Services = () => {
  return (
    <>
    <Header/>
    <SlideUpWrapper>
        <div className={style.TermAndPolicy}>
            <div className={style.authnumberParent}>
                                            <img className={style.subtractIcon} loading="eager" alt="" src="/Header_icon.svg" />

                                            <img className={style.authnumberIcon} loading="eager" alt="" src="/authnumber_1.svg" />
                                        </div>
            <div className={style.TermsandPolicyBox}>
                <div>
                    <h1 className={style.TermAndPolicyHeading}>Background Verification Services</h1>
                </div>
                <div>

                    <div style={{textAlign:"center"}}><h3 className={style.heading}>AuthBridge Research Services Private Limited</h3></div>
                </div>
                <div>
                    <div>
                        <h2 className={style.heading}>Terms</h2>
                    </div>

                    <div>

                        <p className={style.paragraph}>At AuthBridge Research Services Private Limited, we help organizations, recruiters, and individuals make informed decisions by providing trusted and accurate background verification of ex-employees.
                        Our service ensures that you get reliable insights into the past employment of candidates, helping you hire with confidence.</p>
                    </div>
                </div>
                <div>
                    <div>
                        <h2 className={style.heading}>How It Works</h2>
                    </div>

                    <div>
                        <ul>
                            <li>Submit Request – Share the basic details of the ex-employee you want verified</li>
                            <li>Verification Process – Our experts connect with relevant sources, employers, and databases.</li>
                            <li>Report Delivery – You receive a detailed verification report, digitally signed and time-stamped</li>
                        </ul>
                    </div>
                </div>
                <div>
                    <div>
                        <h2 className={style.heading}>Pricing & Charges</h2>
                    </div>
                    <div>
                        <p className={style.paragraph}>✅ For Indian Clients (National):</p>
                        <ul>
                            <li>Service Fee: ₹[Base Price]</li>
                            <li>+ 18% GST (as per Govt. regulations)</li>

                            <li>+ Payment Gateway Charges (as per Razorpay card/payment mode)</li>

                        </ul>

                        <p className={style.paragraph}>✅ For International Clients</p>
                        <ul>
                            <li>Service Fee: USD [Base Price]</li>
                            <li>No GST applicable</li>

                            <li>+ Payment Gateway Charges (as per Razorpay card/payment mode)</li>

                        </ul>
                        
                    </div>
                </div>
                <div>
                    <div>
                        <h2 className={style.heading}>Payments</h2>
                    </div>
                    <div>
                        <p className={style.paragraph}>
                        We accept secure online payments via Razorpay Payment Gateway.
                        </p>
                    </div>
                    <ul>
                            <li>All major debit/credit cards, UPI, net banking, and wallets are supported.</li>
                            <li>International clients can pay using their international cards.</li>

                            <li>Payment gateway charges (as applicable) will be added to your final bill.</li>

                        </ul>
                </div>
            <div>
                <div>
                    <h3>Authnumber is an expert offering from Authbridge</h3>
                </div>
                </div>
        </div>
        </div>
    </SlideUpWrapper>
    </>
  )
}

export default Services